export default "__VITE_ASSET__CyRohreT__"